(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* Toasts */
  function toast(message, opts) {
    var box = $('[data-toasts]');
    if (!box) return;
    opts = opts || {};
    var el = document.createElement('div');
    el.className = 'toast' + (opts.error ? ' toast--error' : '');
    el.setAttribute('role', opts.error ? 'alert' : 'status');
    var text = document.createElement('span');
    text.textContent = message;
    el.appendChild(text);
    if (opts.cartLink) {
      var a = document.createElement('a');
      a.href = window.routes.cart_url;
      a.textContent = 'View cart';
      el.appendChild(a);
    }
    box.appendChild(el);
    setTimeout(function () { el.remove(); }, 5000);
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (n) {
          n.textContent = cart.item_count;
          n.classList.toggle('is-empty', cart.item_count === 0);
        });
        $$('[data-battery]').forEach(function (b) {
          var segs = parseInt(b.getAttribute('data-segments'), 10) || 5;
          var lit = Math.min(cart.item_count, segs);
          $$('.battery__seg', b).forEach(function (s, i) { s.classList.toggle('is-on', i < lit); });
          b.classList.toggle('is-full', lit >= segs);
        });
      });
  }

  /* Charging flash: segments light up one after another when something is added */
  function chargeFlash() {
    $$('[data-battery]').forEach(function (b) {
      b.classList.remove('is-charging');
      void b.offsetWidth;
      b.classList.add('is-charging');
      setTimeout(function () { b.classList.remove('is-charging'); }, 1500);
    });
  }

  /* Mobile nav and quantity steppers (delegated) */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (toggle) {
      var open = document.body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      return;
    }
    var step = e.target.closest('[data-qty-minus], [data-qty-plus]');
    if (step) {
      var input = $('[data-qty-input]', step.closest('.qty'));
      var min = parseInt(input.min || '0', 10);
      var val = parseInt(input.value || '0', 10) || 0;
      val += step.hasAttribute('data-qty-plus') ? 1 : -1;
      input.value = Math.max(min, val);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  /* Gallery */
  function showMedia(root, id) {
    $$('.gallery__slide', root).forEach(function (s) {
      s.classList.toggle('is-active', s.getAttribute('data-media-id') === String(id));
    });
    $$('[data-thumb]', root).forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-thumb') === String(id));
    });
  }

  /* Product section */
  function initProduct(section) {
    var gallery = $('[data-gallery]', section);
    if (gallery) {
      gallery.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-thumb]');
        if (thumb) showMedia(gallery, thumb.getAttribute('data-thumb'));
      });
    }

    var form = $('[data-product-form]', section);
    var json = $('[data-variants]', section);
    if (!form || !json) return;

    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (err) { variants = []; }
    var idInput = $('[data-variant-id]', form);
    var sectionId = section.getAttribute('data-section-id');
    var productUrl = section.getAttribute('data-product-url');

    form.addEventListener('change', function (e) {
      if (!e.target.closest('.opt')) return;

      var selected = $$('.opt', form).map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
      $$('[data-option-label]', form).forEach(function (l, i) { l.textContent = selected[i] || ''; });

      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      })[0];

      var atc = $('[data-atc]', form);
      if (!match) {
        atc.disabled = true;
        atc.textContent = 'Unavailable';
        return;
      }

      idInput.value = match.id;
      if (match.featured_media && gallery) showMedia(gallery, match.featured_media.id);
      history.replaceState({}, '', productUrl + '?variant=' + match.id);

      fetch(productUrl + '?variant=' + match.id + '&section_id=' + sectionId)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          ['[data-price]', '[data-stock]'].forEach(function (sel) {
            var fresh = $(sel, doc), old = $(sel, section);
            if (fresh && old) old.innerHTML = fresh.innerHTML;
          });
          var freshAtc = $('[data-atc]', doc);
          if (freshAtc) {
            atc.disabled = freshAtc.disabled;
            atc.innerHTML = freshAtc.innerHTML;
          }
        })
        .catch(function () { /* keep the current display */ });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-atc]', form);
      if (btn.disabled) return;
      btn.classList.add('is-loading');

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add this to your cart.');
            return data;
          });
        })
        .then(function () { return refreshCartCount(); })
        .then(function () { chargeFlash(); toast('Added to cart', { cartLink: true }); })
        .catch(function (err) { toast(err.message, { error: true }); })
        .then(function () { btn.classList.remove('is-loading'); });
    });
  }

  $$('[data-product-section]').forEach(initProduct);

  /* Collection filters: apply on change */
  $$('[data-filter-form]').forEach(function (form) {
    form.addEventListener('change', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  });

  /* Related products */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-recs]', doc);
        if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* section simply stays empty */ });
  });
})();
